import {IHttpService} from "angular";
import {CompanyInfo} from "../../types/Company";

export class CompanyService {

    public static id = "companyService";

    /** @ngInject */
    public constructor(private $http: IHttpService) {

    }

    /* Response is cached for an hour, so calling this every time isn't as bad as it seems */
    public async companies(hasOptions?: boolean | null, hasCollateral?: boolean | null): Promise<Array<CompanyInfo>> {
        const response = await this.$http.get<Array<any>>("/tradefloor/api/companies");
        const companies = response.data!;
        return companies.filter(c => this.filterHasOptions(c, hasOptions) && this.filterHasCollateral(c, hasCollateral));
    }

    private filterHasOptions(company: CompanyInfo, hasOptions?: boolean | null): boolean {
        if (hasOptions == null) {
            return true;
        } else {
            return company.hasOptions === hasOptions;
        }
    }

    private filterHasCollateral(company: CompanyInfo, hasCollateral?: boolean | null): boolean {
        if (hasCollateral == null) {
            return true;
        } else {
            return company.collateral === hasCollateral;
        }
    }

    public async withOptions(): Promise<Array<CompanyInfo>> {
        return await this.companies(true);
    }

    public async withCollateral(): Promise<Array<CompanyInfo>> {
        return await this.companies(null, true);
    }

    public async filter(input: string, hasOptions?: boolean | null, hasCollateral?: boolean | null): Promise<Array<CompanyInfo>> {
        const companies = await this.companies(hasOptions, hasCollateral);
        return this.findCompanies(companies, input);
    }

    public findCompanies(companies: Array<CompanyInfo>, input: string | null): Array<CompanyInfo> {
        if (input == null) {
            return companies;
        }

        const normalizedFilter = input.toUpperCase();

        const filter = new RegExp(normalizedFilter, "i");

        const codes = companies.filter((c) => c.code.startsWith(normalizedFilter))
                               .sort(this.byCode);
        const names = companies.filter((c) => c.name.match(filter))
                               .filter((c) => codes.indexOf(c) < 0)
                               .sort(this.byName);

        return codes.concat(names).slice(0, 9);
    }

    private byCode(a: any, b: any): number {
        if (a.code > b.code) {
            return 1;
        }
        if (b.code > a.code) {
            return -1;
        }
        return 0;
    }

    private byName(a: any, b: any): number {
        if (a.name > b.name) {
            return 1;
        }
        if (b.name > a.name) {
            return -1;
        }
        return 0;
    }
}
